<template>
  <client-only>
    <checkout-apple-pay-button v-if="isApplePayEnabled" class="w-full" @click="triggerApplePaySession" />
  </client-only>
</template>

<script lang="ts" setup>
const { allowApplePayOrderOnPDP, allowApplePayOrderOnPDPWithBopis } = useFeatureFlags()
const {
  shippingMethod,
  triggerApplePaySession
} = usePdp()

const isApplePayEnabled = computed(() =>
  allowApplePayOrderOnPDP
  && window.ApplePaySession
  && (allowApplePayOrderOnPDPWithBopis || shippingMethod.value !== 'pickup')
)
</script>
